// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"lp-z","slideIn":"mp-z"};